// import simpleScrolling from '../simpleScrolling'
// import helper from '../helper';


// const _h = (obj) => helper.creatObject(obj)

const hayyabuildEvents = () => {

	const effects = document.querySelectorAll('.hb-scrolleffects');

	effects && ( () => {
		for ( let i = 0; i < effects.length; i++ ) {
			const element = effects[i]
			let classes = element.classList
			let indicator = '90%'
			let duration = '70%'
			let scrollEventFrom = {}
			let scrollEventTo = {}
			let run = true
			let easing = 'linear'
			let ease = false
			let debug = false

			classes.forEach( index => {
				if (index.indexOf('hb-scroll_duration_') > -1) {
					duration = 100 - parseInt(index.replace('hb-scroll_duration_', ''))
				} else if (index.indexOf('hb-scroll_easing_') > -1) {
					ease = true;
					indicator = duration = 95
					easing = index.replace('hb-scroll_easing_', '')
				}
			})

			if ( classes.contains('hb-parallax-up') || classes.contains('hb-parallax-down') ) {
				duration = 'OutOfViewPort';
				indicator = '100%';
			}

			const left = window.innerWidth - element.offsetLeft // TODO: check this one
			const right = element.offsetLeft + element.offsetWidth
			const top = element.offsetTop - element.offsetHeight
			const bottom = element.offsetBottom + element.offsetHeight


			if (classes.contains('hb-scale-out')) {
				scrollEventFrom = {
					scale: 1.5,
				};
				scrollEventTo = {
					scale: 1,
				};
				run = true;
			} else if (classes.contains('hb-scale-in')) {
				scrollEventFrom = {
					scale: 0,
				};
				scrollEventTo = {
					scale: 1,
				};
				run = true;
			}

			if (classes.contains('hb-slide-left')) {
				scrollEventFrom = {
					translateX: 150,
					...scrollEventFrom
				};
				scrollEventTo = {
					translateX: '0',
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-slide-right')) {
				scrollEventFrom = {
					translateX: -150,
					...scrollEventFrom
				};
				scrollEventTo = {
					translateX: '0',
					...scrollEventTo
				};
				run = true;
			}

			if (classes.contains('hb-slide-up')) {
				scrollEventFrom = {
					translateY: 150,
					...scrollEventFrom
				};
				scrollEventTo = {
					translateY: '0',
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-slide-down')) {
				scrollEventFrom = {
					translateY: '0',
					...scrollEventFrom
				};
				scrollEventTo = {
					translateY: -150,
					...scrollEventTo
				};
				run = true;
			}


			// rotation
			if (classes.contains('hb-left-rotation')) {
				scrollEventFrom = {
					rotateY: -90,
					...scrollEventFrom
				};
				scrollEventTo = {
					rotateY: 0,
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-right-rotation')) {
				scrollEventFrom = {
					rotateY: 90,
					...scrollEventFrom
				};
				scrollEventTo = {
					rotateY: 0,
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-up-rotation')) {
				scrollEventFrom = {
					rotateX: -90,
					...scrollEventFrom
				};
				scrollEventTo = {
					rotateX: 0,
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-down-rotation')) {
				scrollEventFrom = {
					rotateX: 90,
					...scrollEventFrom
				};
				scrollEventTo = {
					rotateX: 0,
					...scrollEventTo
				};
				run = true;
			}

			if (classes.contains('hb-fade-in')) {
				scrollEventFrom = {
					opacity: 0,
					...scrollEventFrom
				};
				scrollEventTo = {
					opacity: 1,
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-fade-out')) {
				scrollEventFrom = {
					opacity: 1,
					...scrollEventFrom
				};
				scrollEventTo = {
					opacity: 0,
					...scrollEventTo
				};
				run = true;
			}

			if (classes.contains('hb-parallax-up')) {
				scrollEventFrom = {
					backgroundPosition: '0',
					...scrollEventFrom
				};
				scrollEventTo = {
					backgroundPosition: '100',
					...scrollEventTo
				};
				run = true;
			} else if (classes.contains('hb-parallax-down')) {
				scrollEventFrom = {
					backgroundPosition: '100',
					...scrollEventFrom
				};
				scrollEventTo = {
					backgroundPosition: '0',
					...scrollEventTo
				};
				run = true;
			}

			run && new superEvents(element).scroll({
				indicator: indicator,
				duration: duration,
				listener: 'load',
				// easing: easing,
				debug: debug
			})
			.fromTo(
				scrollEventFrom,
				scrollEventTo
			)
			.easing(
				easing,
				0.7,
				false,
				ease
			)

		}

		// const scrollEventFrom = { backgroundColor: '#FF7070'/*, translateY: -20 */}
		// const scrollEventTo = { backgroundColor: '#77B2FF'/*, translateY: 0 */}
		// const easing = 'linear'
		// const ease = true

		// // hayyabuild-button2-5724
		// const testSource = document.querySelector('.hayyabuild-button2-5724')

		// const testTarget1 = document.querySelector('.hayyabuild-button2-5724')
		// const testTarget2 = document.querySelector('.hayyabuild-button2-5808 a')
		// const testTarget3 = document.querySelector('.hayyabuild-button2-2353 a')
		// const testTarget4 = document.querySelector('.hayyabuild-button2-4680 a')

		// const testTarget = [ testTarget1, testTarget2, testTarget3 ,testTarget4 ]

		// new superEvents({source: testSource, target: testSource})
		// .mousemove()
		// .fromTo(
		// 	scrollEventFrom,
		// 	scrollEventTo
		// )
		// .easing(
		// 	easing,
		// 	.5,
		// 	false,
		// 	ease
		// )


	})();
}

export default hayyabuildEvents;
